import Service from "../../AuthService";

const Seller = {
    getSeller() {
        return Service.get("/seller");
    },
    getListQuota() {
        return Service.get("/quota_list");
    },
    getSellerQuota() {
        return Service.get("/seller_quota");
    },
    generateNO() {
        return Service.get("/generate_quota_no");
    },
    checkYTD(data) {
        return Service.get(`/quota_check_ytd?product_id=${data.id}`);
    },
    quotaSubmit(data) {
        return Service.post('/quota_submit', data);
    },
    quotaShow(data) {
        return Service.get('/quota_show?id=' + data);
    },
    quotaSaleShow(data) {
        return Service.get('/quota_sale_show?id=' + data);
    },
    quotaSaleHistory(data) {
        return Service.get('/quota_sale_history?id=' + data);
    },
    showSeller(id) {
        return Service.get("/seller/" + id);
    },
    updateSeller(id, data) {
        return Service.put("/seller/" + id, data);
    },
    createSeller(data) {
        return Service.post("/seller", data);
    },
    deleteSeller(id) {
        return Service.delete("/seller/" + id);
    },
    searchSeller(keyword) {
        return Service.post("/search-seller?sale=" + keyword);
    },
    getCustomerFromSale(data) {
        //console.log("/customer-from-sale?sale_id="+data);
        return Service.get("/customer-from-sale?sale_id=" + data);
    },
    deleteQuota(id) {
        return Service.get('/quota_delete?id=' + id);
    },
};
export default Seller;
